<template>
  <b-row
    v-if="
      record.company.classification[classification] &&
      record.company.classification[classification].enabled &&
      record.classification[classification]
    "
  >
    <b-col cols="12">
      <b-form-group :label="label">
        <b-form-select
          :value="record.classification[classification]"
          type="text"
          disabled
          plain
          :options="classificationOptions[classification]"
        ></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
  <b-row
    v-else-if="
      classificationGroup &&
      classificationGroup.enabled &&
      record.classification[classification]
    "
  >
    <b-col cols="12">
      <b-form-group :label="label">
        <b-form-select
          :value="record.classification[classification]"
          type="text"
          disabled
          plain
          :options="
            classificationGroup.options.map((option) => {
              return { value: option._id, text: option.value };
            })
          "
        ></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import { getActiveCompanyClassificationGroupsOptions } from "../../api/company";

export default {
  name: "ClassificationViewer",
  props: {
    record: {
      type: Object,
      required: true,
    },
    classification: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      classificationGroups: [],
    };
  },
  computed: {
    ...mapGetters(["classificationOptions"]),
    classificationGroup() {
      return this.classificationGroups.find(
        (group) =>
          group._id === parseInt(this.classification.replace("custom_", ""))
      );
    },
  },
  async created() {
    const response = await getActiveCompanyClassificationGroupsOptions(
      this.record.company._id,
      this.type
    );
    this.classificationGroups = response.data;
  },
};
</script>
